/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  EntityTenantSetting,
  EntityTenantSettingsSchemaListItem,
  EntityTenantSettingsSchemaUiOptions,
} from '../../../../Services/tenant-settings';

/**
 * Get the UI access options for a setting based on its schema.
 */
export const getUiOptionsForSetting = (
  schemas: Array<EntityTenantSettingsSchemaListItem>,
  setting: EntityTenantSetting,
): EntityTenantSettingsSchemaUiOptions | null => {
  const settingSchema = schemas.find((schema) => schema.schemaId === setting.schemaId);

  if (settingSchema) {
    return settingSchema.uiOptions;
  }

  return null;
};
